import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Toaster } from '../components/ui/sonner';
import Header from '../components/Header';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import StickyCTA from '../components/StickyCTA';
import SEO from '../components/SEO';
import HeroPlataforma from '../components/home/HeroPlataforma';
import {
  DosPuertas,
  ComoFunciona,
  SeccionTerritorio,
  Audiencias,
  Cierre,
  FAQ_HOME,
} from '../components/home/Secciones';
import { useDibujaAlVer } from '../hooks/useDibujaAlVer';
import { useRevealOnScroll } from '../hooks/useRevealOnScroll';
import { getHreflangsForUrl } from '../data/locales';
import { OG_HOME } from '../lib/og';
import { URL_SOLICITAR_ACCESO } from '../lib/urbanismoBase';

/**
 * Home de geovis.es: GeoVis como plataforma con dos puertas, Urbanismo (la apuesta
 * principal, primero) y Territorio con el mismo peso. El detalle territorial completo
 * vive en /territorio; aquí se conservan sus anclas antiguas (#producto, #features,
 * #precios) en la sección de Territorio.
 */
export default function HomePage() {
  const navigate = useNavigate();
  // Las preguntas (FAQ) entran con data-reveal: sin este hook se quedan invisibles.
  useRevealOnScroll('[data-reveal]');
  useDibujaAlVer();

  return (
    <div className="min-h-screen relative">
      {/* La home es la raíz del clúster hreflang: hay que volver a declararlo, SEO.js
          borra los alternates estáticos de index.html al montar. */}
      <SEO
        title="GeoVis · urbanismo por parcela y análisis territorial con datos oficiales"
        description="Qué se puede construir en cada parcela, con artículo y página del plan, y todo lo que afecta al terreno: +80 capas oficiales en 15 países."
        url="/"
        image={OG_HOME}
        hreflangs={getHreflangsForUrl()}
      />
      <div className="site-bg" aria-hidden="true">
        <div className="site-bg__image" style={{ backgroundImage: 'url(/hero-bg-light.webp)' }} />
        <div className="site-bg__wash" />
        <div className="noise-overlay" />
      </div>

      <Header onOpenDemo={() => navigate('/demo')} />
      <main>
        <HeroPlataforma />
        <DosPuertas />
        <ComoFunciona />
        <SeccionTerritorio />
        <Audiencias />
        <FAQ items={FAQ_HOME} subtitulo="Lo esencial de las dos puertas, sin ruido." />
        <Cierre />
      </main>
      <Footer onOpenDemo={() => navigate('/demo')} />
      <StickyCTA texto="Solicitar acceso" href={URL_SOLICITAR_ACCESO} />
      <Toaster richColors position="top-right" />
    </div>
  );
}
